export default __webpack_public_path__ + "static/launch-5ff620ee19ca7d4c6a1e9ed6e4b00cdd.jpg";